import { createContext, useCallback, useContext, useEffect, useState } from "react";
import { translations } from "./translations";

const LangContext = createContext(null);
export const RTL = ["ar", "ur"];

export function LangProvider({ children }) {
  const [lang, setLang] = useState(() => localStorage.getItem("mohassib_lang") || "fr");
  useEffect(() => {
    localStorage.setItem("mohassib_lang", lang);
    document.documentElement.lang = lang;
    document.documentElement.dir = RTL.includes(lang) ? "rtl" : "ltr";
  }, [lang]);
  const t = useCallback((k) => translations[lang][k] ?? translations.en[k] ?? k, [lang]);
  const accName = useCallback(
    (a) => (!a ? "" : (lang === "fr" && a.name_fr) || (lang === "ar" && a.name_ar) || a.name),
    [lang]
  );
  const locale = { ar: "ar-AE", fr: "fr-FR", ur: "ur-PK", hi: "hi-IN", tl: "fil-PH" }[lang] || "en-GB";
  return <LangContext.Provider value={{ lang, setLang, t, accName, locale }}>{children}</LangContext.Provider>;
}

export const useLang = () => useContext(LangContext);
